<form>
    <div class="row mb-3" *ngFor="let expense of expenses.value; index as i">
        <div class="col-9 col-lg-6 pe-0 mb-2">
            <pace-core-dropdown
                [(model)]="expense.expenseCode"
                [parentForm]="parentForm"
                id="dropdownExpenseCode"
            ></pace-core-dropdown>
        </div>
        <div class="d-block d-lg-none col text-end">
            <button
                class="btn btn-warning"
                (click)="deleteExpense(i)"
                [disabled]="readonly"
                [attr.aria-label]="('TIMESHEET_EXPENSES_DELETE_LABEL' | translate) + i"
            >
                <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
        </div>
        <div class="col-9 col-lg-4 pe-0">
            <pace-core-text-input
                [(model)]="expense.expenseValue"
                [parentForm]="parentForm"
                [ariaLabel]="('TIMESHEET_EXPENSES_EXPENSE_VALUE_LABEL' | translate) + i"
            ></pace-core-text-input>
        </div>
        <div class="col-2 d-none d-lg-block">
            <button
                class="btn btn-warning"
                (click)="deleteExpense(i)"
                [disabled]="readonly"
                [attr.aria-label]="('TIMESHEET_EXPENSES_DELETE_LABEL' | translate) + i"
            >
                <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col" [ngClass]="!expenses.value.length ? 'text-md-start text-end' : 'text-end'">
            <button
                class="btn btn-primary"
                translate="CONFIRMATION_EXPENSES_ADD_EXPENSES_LABEL"
                (click)="addNewExpense()"
                [disabled]="readonly"
            ></button>
        </div>
    </div>
</form>
